import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import styled from 'styled-components';
import Strip from '@magalu/stereo-ui/atoms/Strip';
import Grid from '@magalu/stereo-ui/atoms/Grid';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles/build/utils';
var Container = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 76px;\n  background-color: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n"])), function (props) {
  return getPaletteColor('background.primary')(props);
});
var GridContent = styled(Grid)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-content: center;\n"])));
var StripHeader = styled(Strip)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  && {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    width: 100%;\n    position: static;\n  }\n"])), function (props) {
  return themeGet('radii.small')(props);
}, function (props) {
  return themeGet('radii.small')(props);
});
export { Container, GridContent, StripHeader };